import { render } from "./Main.vue?vue&type=template&id=58ea12dc"
const script = {}
script.render = render

export default script